import type { PropsWithChildren, ReactElement } from 'react';
import { MD3LightTheme, Provider as PaperProvider } from 'react-native-paper';
import { TamaguiProvider, Theme } from 'tamagui';
import { appConfig as tamaguiConfig } from 'tamagui.config';

const paperTheme = {
  ...MD3LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    primary:
      tamaguiConfig.tokens?.color?.brand?.val ??
      tamaguiConfig.tokens?.color?.brand ??
      MD3LightTheme.colors.primary,
    background: tamaguiConfig.themes.light.background.val,
    surface: tamaguiConfig.themes.light.background.val,
  },
};

export const ThemeProvider = ({
  children,
}: PropsWithChildren): ReactElement => (
  <PaperProvider theme={paperTheme}>
    <TamaguiProvider config={tamaguiConfig}>
      <Theme name="light">{children}</Theme>
    </TamaguiProvider>
  </PaperProvider>
);
